<template>
  <article v-editable="blok" class="article-wrapper">
    <component :is="pageBannerComponent" v-if="pageBanner" :blok="pageBanner">
      <template #filters>
        <component :is="filterComponent" v-if="hasFilterBar" />
      </template>
    </component>
    <PaginationTotals
      v-if="cards.length"
      :current-page="currentPage"
      :pages-total="pagesTotal"
      :total-items="totalItems"
    />
    <PaginationNoResults v-if="status==='success' && !cards.length" />
    <PaginationError v-else-if="status==='error'" />
    <section v-if="cards.length" class="cards-list">
      <!-- card list -->
      <component
        :is="listComponent"
        :blok="cards"
        :content-type="contentType"
        :is-filtered="isFiltered"
      />
    </section>
    <PaginationPaginate
      v-if="hasPages"
      :margin-pages="1"
      :page-range="3"
      :pages-total="pagesTotal"
      :value="currentPage"
      @on-set-page="setPage"
    />
    <!-- hr.no-pagination(v-else-if="cards.length" aria-label="Nothing more to load") -->
    <div v-if="blocks.length" class="container">
      <component
        :is="block.component"
        v-for="block in blocks"
        :key="block._uid"
        :blok="block"
      />
    </div>
    <ContentSubscribe v-if="!pageContainsSubscriptionForm" />
  </article>
</template>

<script setup lang="ts">
import type { LandingPageStoryblok } from '~/types/storyblok'
const route = useRoute()
const props = defineProps<{
  blok: LandingPageStoryblok
}>()
const {
  pageBanner,
  pageBannerComponent,
  blocks,
  pageContainsSubscriptionForm,
} = useStoryContent(toRefs(props))
const contentType = computed(() => route.path.replace(/\//g, ''))
const listComponent = computed(() => contentType.value + 'List')
const filterComponent = computed(() => contentType.value + 'FilterBar')
const componentType = computed(() => slugToComponentTypeName(contentType.value))

const { isFiltered, hasFilterBar, filterQuery, sortByQuery } = useFilters({
  contentType,
  componentType,
})

const apiOptions = computed(() => ({
  starts_with: contentType.value + '/',
  sort_by: 'first_published_at:desc',
  is_startpage: false,
  ...filterQuery.value,
  ...sortByQuery.value,
}))

const {
  stories: cards,
  currentPage,
  pagesTotal,
  totalItems,
  refresh,
  setPage,
  hasPages,
  status
} = await usePagination({ apiOptions })

watch(props.blok, () => refresh())

onBeforeMount(() => {
  if (isFiltered.value) refresh()
})
</script>
